<section *ngIf="showModal" class="main-side-nav dialog">
    <section class="container-dynamic-grid">
        <!-- <div class="closing-modal-btn" (click)="choice('Yes')" aria-label="Close">
            <i class="fa fa-2x fas fa-times"></i>
        </div> -->
        <div class="modal-title">
            <div class="firstPara">{{firstPara}}</div>
            <div class="scdPara">{{scdPara}}</div>
        </div>
        <div class="btn-management">
            <div class="form-group col-md-4">
                <button (click)="choice('Yes')" class="form-control btn btn btn-primary primary-default-btn">Yes</button>
            </div>
            <div class="form-group col-md-4">
                <button (click)="choice('No')" class="form-control btn btn btn-primary primary-default-btn">No</button>
            </div>
        </div>
    </section>
</section>